import Modal from "@/components/modal/modal.vue";
import vClickOutside from "v-click-outside";

/** Modal with title, description, and yes/no buttons */
export default {
	props: {
		title: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
	},

	components: { Modal },

	directives: { clickOutside: vClickOutside.directive },

	methods: {
		confirm() {
			this.$emit("confirm");
		},
		cancel() {
			this.$emit("cancel");
		},
	},
};
